export default __webpack_public_path__ + "static/ForgetSectionRight_es-2fd247a9d5aaf4d92adc926b67fad8e2.png";